import { useTheme } from "styled-components";
import { PATHS } from "../../../config/permissionsPaths";
import useAuth from "../../../hooks/useAuth";
import { TableWrapper, Table, Th, Td, TdDesc, TdEst, IconGroup, IconAlert } from "../Home.styles";
import { convertirDecimalAnios } from "../../../utils/dateUtils";
import icons from "../../../assets/icons/iconMap";

const ResultTable = ({ data, handleOpenModal, setSelectedResult, openModal }) => {
  const { hasPermission } = useAuth();
  const theme = useTheme();

  // Función para determinar el estilo de la fila según vigencia
  const getRowStyle = (vigencia) => {
    return vigencia === "Vencida"
      ? { color: theme.TextAlert || "#dc3545" }
      : { color: theme.text || "#000" };
  };

  // Función para renderizar el ícono de alerta
  const renderAlertIcon = (item) => {
    if (!item.MaxDeFecha_APIM || item.Cod_Diagnostico.trim() === "") {
      return null;
    }

    if (item.alerta === "1") {
      return (
        <img
          src={icons["ok"]}
          alt="Estado OK"
          title="Estado Normal"
          style={{ width: 17, height: 17 }}
        />
      );
    } else if (item.alerta === "2") {
      return (
        <img
          src={icons["advertenciaYellow"]}
          alt="Alerta"
          title="Requiere Atención"
          style={{ width: 17, height: 17 }}
        />
      );
    }
    return null;
  };

  return (
    <TableWrapper>
      <Table>
        <thead>
          <tr>
            <Th>Actividad</Th>
            <Th title="Tiempo entre una actividad y la siguiente" style={{ cursor: "help" }}>
              Frecuencia
            </Th>
            <Th title="Fecha en la que se realizó la última actividad" style={{ cursor: "help" }}>
              Última Act.
            </Th>
            <Th>Resultado</Th>
            <Th>Estado</Th>
            <Th>Alerta</Th>
            <Th>Acciones</Th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr key={item.id || `row-${index}`} style={getRowStyle(item.Vigencia)}>
                {/* Actividad */}
                <TdDesc $striped={index % 2 === 0}>
                  {item.APIM || "N/A"}
                </TdDesc>

                {/* Frecuencia */}
                <Td $striped={index % 2 === 0}>
                  {item.MinDeVigencia ? convertirDecimalAnios(item.MinDeVigencia) : "-"}
                </Td>

                {/* Última Actividad */}
                <Td $striped={index % 2 === 0}>
                  {item.MaxDeFecha_APIM}
                </Td>

                {/* Resultado */}
                <Td
                  $striped={index % 2 === 0}
                  style={!item.MaxDeFecha_APIM ? { textAlign: "center" } : {}}
                >
                  {item.MaxDeFecha_APIM ? item.Cod_Diagnostico || "" : ""}
                </Td>

                {/* Estado */}
                <TdEst $striped={index % 2 === 0}>
                  {item.MaxDeFecha_APIM ? item.Vigencia || "" : ""}
                </TdEst>

                {/* Alerta */}
                <TdEst
                  $striped={index % 2 === 0}
                  style={!item.MaxDeFecha_APIM ? { textAlign: "center" } : {}}
                >
                  <IconAlert>
                    {renderAlertIcon(item)}
                  </IconAlert>
                </TdEst>

                {/* Acciones */}
                <TdEst $striped={index % 2 === 0}>
                  <IconGroup>
                    {/* Botón de Información */}
                    <img
                      src={icons["information"]}
                      alt="Ver información"
                      title="Ver detalles de la actividad"
                      style={{ width: 17, height: 17, cursor: "pointer" }}
                      onClick={() => handleOpenModal(item.cons + '_' + item.subgrupo, item.APIM)}
                    />

                    {/* Botón de Cargar Resultado - Visible siempre que tenga permiso */}
                    {hasPermission(PATHS.CARGAR_RESULTADO) && (
                      <img
                        src={icons["pencil"]}
                        alt="Cargar resultado"
                        title="Cargar Resultado"
                        style={{ width: 17, height: 17, cursor: "pointer" }}
                        onClick={() => {
                          setSelectedResult({
                            cons: item.cons,
                            desc: item.APIM
                          });
                          openModal("result");
                        }}
                      />
                    )}
                  </IconGroup>
                </TdEst>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: "center", padding: "20px", fontStyle: "italic", color: "#999" }}>
                No hay resultados disponibles para mostrar
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </TableWrapper>
  );
};

export default ResultTable;
